export const ADMIN_ROUTES = {
  LOGIN: "/dashboard/login",
  RESET_PASSWORD: "/admin/reset-password",
  ROOT: "/admin",
  PROFILE: "profile",
  AGENT: "agent",
  NEW_AGENT: "agent/new",
  EDIT_AGENT: "agent/edit/:agentId",
  VIEW_AGENT: "agent/view/:agentId",
  CATEGORY_AMENITIES: "categories/amenities",
  CATEGORY_MAIN_CATEGORIES: "categories/categories",
  CATEGORY_MAIN_SUB_CATEGORIES: "categories/sub-categories",
  CATEGORY_IMAGE_CATEGORIES: "categories/image-categories",
  CATEGORY_FACTS: "categories/facts-features",
  CATEGORY_FAQS_CATEGORY_LIST: "categories/facts-category",
  GROUPS: "categories/groups",
  AREA_LIST: "categories/areas-list",
  REAL_ESTATE_PROPERTIES: "real-estate/properties",
  REAL_ESTATE_NEW_PROPERTIES: "real-estate/properties/new",
  REAL_ESTATE_EDIT_PROPERTIES: "real-estate/properties/edit/:propertyId",
  REAL_ESTATE_VIEW_PROPERTY: "real-estate/properties/view/:propertyId",
  REAL_ESTATE_PROJECTS: "real-estate/projects",
  REAL_ESTATE_NEW_PROJECTS: "real-estate/projects/new",
  REAL_ESTATE_EDIT_PROJECTS: "real-estate/projects/edit/:projectId",
  REAL_ESTATE_VIEW_PROJECT: "real-estate/projects/view/:projectId",
  BUILDERS: "builders",
  NEW_BUILDERS: "builders/new",
  EDIT_BUILDERS: "builders/edit/:builderId",
  VIEW_BUILDER: "builders/view/:builderId",
  SALES_TEAM: "sales-team",
  NEW_SALES_TEAM: "sales-team/new",
  EDIT_SALES_TEAM: "sales-team/edit/:memberId",
  LOCATION_HISTORY_SALES_TEAM: "sales-team/location-history",
  LOCATION_HISTORY_SALES_TEAM_ID: "sales-team/location-history/:memberId",
  CUSTOMER: "customer",
  MANAGE_STAFF: "manage-staff/all-staff",
  MANAGE_STAFF_NEW: "manage-staff/all-staff/new",
  MANAGE_STAFF_EDIT: "manage-staff/all-staff/edit/:staffId",
  MANAGE_STAFF_ROLES: "manage-staff/roles",
  MANAGE_STAFF_NEW_ROLES: "manage-staff/roles/new",
  MANAGE_STAFF_EDIT_ROLES: "manage-staff/roles/edit/:roleId",
  CONTENT_MANAGEMENT: "content-management",
  CONTENT_MANAGEMENT_FAQS: "content-management/faqs",
  CONTENT_MANAGEMENT_FAQS_NEW: "content-management/faqs/new",
  CONTENT_MANAGEMENT_FAQS_EDIT: "content-management/faqs/edit/:faqsId",
  CONTENT_MANAGEMENT_TERMS_SERVICE: "content-management/terms-services",
  CONTENT_MANAGEMENT_SLIDER_IMAGE: "content-management/slider-image",
  CONTENT_MANAGEMENT_ABOUT_US: "content-management/about",
  CONTENT_MANAGEMENT_ADD_SLIDER_IMAGE:
    "content-management/slider-image/new-slider",
  CONTENT_MANAGEMENT_EDIT_SLIDER_IMAGE:
    "content-management/slider-image/edit-slider/:sliderId",
  ENQUIRY: "enquiry",
  VIEW_ENQUIRY: "enquiry/view/:enquiryId",
  NOTIFICATION: "notification",
  FEEDBACK: "feedback",
  CONTACT: "contact",
  BLOG_POST: "blog-post",
  NEW_BLOG: "blog-post/new",
  EDIT_BLOG: "blog-post/edit/:blogId",
  REELS: "reels",
  REPORTS_PROPERTY_LIST: "reports/property-reports",
  REPORTS_PROJECT_LIST: "reports/project-reports",
  REPORTS_REELS_LIST: "reports/reel-reports",
  REPORTS_USERS_LIST: "reports/user-reports",
  REPORTS_PROPERTY_ID: "reports/property-reports/:propertyId",
  REPORTS_PROJECT_ID: "reports/project-reports/:projectId",
  REPORTS_REEL_ID: "reports/reel-reports/:reelId",
  REPORTS_USER_ID: "reports/user-reports/:userId",
  LEADS: "leads",
  LEADS_VIEW: "leads/view",
  LEADS_VIEW_LEAD_ID: "leads/view/:leadId",
  LEADS_EDIT: "leads/edit",
  LEADS_EDIT_LEAD_ID: "leads/edit/:leadId",
  ADVERTISE: "advertise",
  NEW_LEAD: "leads/new",
  EDIT_LEAD: "leads/edit/:leadId",
  SALES_RECORDS: "sales-records",
  SALES_RECORDS_VIEW: "sales-records/:salesRecordId",
  WHATS_APP_ANALYTICS: "whatsapp-analytics",
  WHATS_APP_SEND_MESSAGE: ":pageName/whatsapp/send",
  BOOK_CALL_LIST: "book-call",
  SEO: "seo",
};

export const BUILDER_ROUTES = {
  ROOT: "/builder",
  LOGIN: "/dashboard/login",
  DASHBOARD: "/builder",
  PROPERTIES: "properties",
  NEW_PROPERTIES: "properties/new",
  EDIT_PROPERTIES: "properties/edit/:propertyId",
  VIEW_PROPERTY: "properties/view/:propertyId",
  PROJECTS: "projects",
  NEW_PROJECTS: "projects/new",
  EDIT_PROJECTS: "projects/edit/:projectId",
  VIEW_PROJECT: "projects/view/:projectId",
  MEETINGS: "meetings",
  VIEW_MEETING: "meetings/view/:meetingId",
  ENQUIRY: "enquiry",
  VIEW_ENQUIRY: "enquiry/view/:enquiryId",
  PROFILE: "profile",
  AGENT: "agent",
  NEW_AGENT: "agent/new",
  EDIT_AGENT: "agent/edit/:agentId",
  VIEW_AGENT: "agent/view/:agentId",
  SALES_TEAM: "sales-team",
  NEW_SALES_TEAM: "sales-team/new",
  EDIT_SALES_TEAM: "sales-team/edit/:memberId",
  LOCATION_HISTORY_SALES_TEAM: "sales-team/location-history",
  LOCATION_HISTORY_SALES_TEAM_ID: "sales-team/location-history/:memberId",
  REPORTS_PROPERTY_LIST: "reports/property-reports",
  REPORTS_PROJECT_LIST: "reports/project-reports",
  REPORTS_PROPERTY_ID: "reports/property-reports/:propertyId",
  REPORTS_PROJECT_ID: "reports/project-reports/:projectId",
  LEADS: "leads",
  LEADS_VIEW: "leads/view",
  LEADS_VIEW_LEAD_ID: "leads/view/:leadId",
  LEADS_EDIT: "leads/edit",
  LEADS_EDIT_LEAD_ID: "leads/edit/:leadId",
  NEW_LEAD: "leads/new",
  EDIT_LEAD: "leads/edit/:leadId",
};

export const AGENT_ROUTES = {
  ROOT: "/agent",
  LOGIN: "/dashboard/login",
  PROFILE: "profile",
  PROJECTS: "projects",
  VIEW_PROJECT: "projects/view/:projectId",
  PROPERTIES: "properties",
  NEW_PROJECTS: "projects/new",
  EDIT_PROJECTS: "projects/edit/:projectId",
  VIEW_PROPERTY: "properties/view/:propertyId",
  NEW_PROPERTIES: "properties/new",
  EDIT_PROPERTIES: "properties/edit/:propertyId",
  MEETINGS: "meetings",
  AVAILABILITY: "availability",
  VIEW_MEETING: "meetings/view/:meetingId",
  ENQUIRY: "enquiry",
  VIEW_ENQUIRY: "enquiry/view/:enquiryId",
  REPORTS_PROPERTY_LIST: "reports/property-reports",
  REPORTS_PROJECT_LIST: "reports/project-reports",
  REPORTS_PROPERTY_ID: "reports/property-reports/:propertyId",
  REPORTS_PROJECT_ID: "reports/project-reports/:projectId",
  CONSULTED: "contsulted",
  SETTINGS: "settings",
};

export const USER_ROUTES = {
  ROOT: "/",
  NOT_FOUND: "*",
  EMI_CALCULATOR: "/emi-calculator",
  PROFILE: "/profile",
  RESET_PASSWORD: "/customer/reset-password",
  BLOG_LIST: "/blogs",
  BLOG_SINGLE: "/blog/:blogId/:slug",
  SAVED_PROPERTY: "/account/saved-property",
  SAVED_PROJECT: "/account/saved-project",
  SAVED_SEARCHES: "/account/saved-searches",
  MANAGE_TOURS: "/account/manage-tours",
  VIEW_MEETING: "/account/manage-tours/view/:meetingId",
  PROPERTY_INFORMATION: "/property-information",
  PROPERTY_INFORMATION_ID: "/property-information/:slug/:propertyId",
  PROJECT_INFORMATION: "/project-information",
  PROJECT_INFORMATION_ID: "/project-information/:slug/:projectId",
  RECENTLY_VIEWED: "/account/recently-viewed",
  YOUR_PROJECT: "/account/your-project",
  ARCHIVED_PROJECT: "/account/archived-project",
  YOUR_NEW_PROJECT: "/account/your-project/new",
  EDIT_YOUR_PROJECT: "/account/your-project/edit/:projectId",
  YOUR_PROPERTY: "/account/your-property",
  ARCHIVED_PROPERTY: "/account/archived-property",
  YOUR_NEW_PROPERTY: "/account/your-property/new",
  EDIT_YOUR_PROPERTY: "/account/your-property/edit/:propertyId",
  ACCOUNT_SETTINGS: "/account/account-settings",
  ACCOUNT_SETTINGS_PROFILE: "/account/account-settings/profile",
  ACCOUNT_SETTINGS_SECURITY: "/account/account-settings/security",
  ACCOUNT_SETTINGS_PURCHASED: "/account/purchased",
  ACCOUNT_SETTINGS_PURCHASED_ID: "/account/purchase-information/:purchasedId",
  ACCOUNT_SETTINGS_NOTIFICATION: "/account/account-settings/notification",
  ACCOUNT_SETTINGS_DOCUMENT_PREFERENCES:
    "/account/account-settings/document-preferences",
  SEARCH: "/search",
  ABOUT_US: "/about",
  TERM_AND_CONDITIONS: "/term-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  VERIFY: "/verify",
  CONTACT_US: "/contact-us",
  HELP_CENTER: "/help-center",
  MENU_ADVERTISE: "/advertise",
  SALES_DATA: "/sales-data",
  REELS: "/reels",
  REELS_FILTER: "/hashtags",
  REELS_FILTER_PARAMS: "/hashtags/:hashtag",
  REELS_FILTER_REEL_PARAMS: "/hashtags/:hashtag/reel/:reelId",
  REEL_ID: "/reels/:reelId",
  USER_AGREEMENT: "/user-agreement",
};

export const SALES_ROUTES = {
  ROOT: "/sales",
  LOGIN: "/dashboard/login",
  PROFILE: "profile",
  DASHBOARD: "/sales",
  ENQUIRY: "enquiry",
  ENQUIRY_VIEW: "enquiry/view",
  ENQUIRY_VIEW_LEAD_ID: "enquiry/view/:leadId",
  ENQUIRY_EDIT: "enquiry/edit",
  ENQUIRY_EDIT_LEAD_ID: "enquiry/edit/:leadId",
  NEW_ENQUIRY: "enquiry/new",
  VIEW_ENQUIRY: "enquiry/view/:enquiryId",
  DRONE_VIEW: "drone-view",
};
